// extracted by mini-css-extract-plugin
export var navigationMenuExpand = "NavigationMenu-module--navigationMenuExpand--3MLnL";
export var navigationMenu = "NavigationMenu-module--navigationMenu--1kvt8";
export var navigationMenuExpanded = "NavigationMenu-module--navigationMenuExpanded--1PXyu";
export var navigationMenuItem = "NavigationMenu-module--navigationMenuItem--3E3Sm";